export default __webpack_public_path__ + "static/media/serviceMobile.bb2c5a9b.png";